import {gql} from "@apollo/client";

export const ANALYZE_CHANGES = gql`
	query AnalyzeChanges
	{
		analyzeChanges {
			stages
			forms {
				formId
				formName
				frontEndName
				clientId
				versionId
				remoteFormsNames
				questions {
					fullId
					definition
					frontEndName
					clientName
					versionId
					extends
					parameters
					subLabelExpression
					name
					label {
						isPresent
						value
					}
					subLabel {
						isPresent
						value
					}
					subLabel {
						isPresent
						value
					}
					labelExpression
					subLabelExpression
					description {
						isPresent
						value
					}
					extraDisplay {
						isPresent
						value
					}
					valueType{
						isPresent
						value
					}
					queryType{
						isPresent
						value
					}
					valueOptions{
						isPresent
						value {
							display
							value
							extraDisplay
							extraDisplayExpression
						}
					}
					unit {
						isPresent
						value
					}
					defaultValue {
						isPresent
						value
					}
					mapping {
						isPresent
						value
					}
					defaultPositioning {
						isPresent
						value {
							afterQuestion
						}
					}
					missingRequiredValueErrorMessage {
						isPresent
						value
					}
					valueMapping
					defaultValueExpression
					visibleExpression
					enabledExpression
					editableExpression
					requiredExpression
					validators
					placeholder {
						isPresent
						value
					}
					inputMask {
						isPresent
						value
					}
					custom {
						postback
					}
					rendererProperties
				}
				layout
			}
			questions {
				fullId
				definition
				frontEndName
				clientName
				versionId
				subLabel {
					isPresent
					value
				}
				extends
				parameters
				subLabelExpression
				name
				label {
					isPresent
					value
				}
				labelExpression
				description {
					isPresent
					value
				}
				extraDisplay {
					isPresent
					value
				}
				valueType{
					isPresent
					value
				}
				queryType{
					isPresent
					value
				}
				valueOptions{
					isPresent
					value {
						display
						value
						extraDisplay
						extraDisplayExpression
					}
				}
				unit {
					isPresent
					value
				}
				defaultValue {
					isPresent
					value
				}
				mapping {
					isPresent
					value
				}
				defaultPositioning {
					isPresent
					value {
						afterQuestion
					}
				}
				missingRequiredValueErrorMessage {
					isPresent
					value
				}
				valueMapping
				defaultValueExpression
				visibleExpression
				enabledExpression
				editableExpression
				requiredExpression
				validators
				placeholder {
					isPresent
					value
				}
				inputMask {
					isPresent
					value
				}
				custom {
					postback
				}
				rendererProperties
			}
		}
	}
`;

export const PUT_QUESTION_SETUP = gql`
	mutation PutQuestionSetup(
		$stage: String
		$questionSetup: QuestionSetupInput!
	){
		putQuestionSetup(
			stage: $stage
			questionSetup: $questionSetup
		) {
			fullId
		}
	}
`;

export const DELETE_QUESTION_SETUP = gql`
	mutation DeleteQuestionSetup(
		$stage: String
		$questionDefinition: String!
		$frontEndName: String
		$clientName: String
	) {
		deleteQuestionSetup(
			stage: $stage
			questionDefinition: $questionDefinition
			frontEndName: $frontEndName
			clientName: $clientName
		) {
			fullId
		}
	}
`;

export const PUT_FORM_SETUP = gql`
	mutation PutFormSetup(
		$stage: String
		$formSetup: FormSetupInput!
	) {
		putFormSetup(
			stage: $stage
			formSetup: $formSetup
		) {
			formId
		}
	}
`;

export const DELETE_FORM_SETUP = gql`
	mutation DeleteFormSetup(
		$stage: String
		$formName: String!
		$frontEndName: String
		$clientName: String
	) {
		deleteFormSetup(
			stage: $stage
			formName: $formName
			frontEndName: $frontEndName
			clientName: $clientName
		) {
			formId
		}
	}
`;
